import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

/**
 * Generic reusable confirmation dialog — pass any title/message/onConfirm.
 * Kept dumb on purpose so it can be reused for other delete/confirm flows too.
 */
const DeleteConfirmModal = ({
  isOpen,
  toggle,
  onConfirm,
  loading,
  title = "Confirm Delete",
  message = "Are you sure you want to delete this record? This action cannot be undone.",
}) => {
  return (
    <Modal isOpen={isOpen} toggle={loading ? undefined : toggle} centered>
      <ModalHeader toggle={loading ? undefined : toggle}>{title}</ModalHeader>
      <ModalBody>
        <p className="mb-0">{message}</p>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={loading}>
          Cancel
        </Button>
        <Button color="danger" onClick={onConfirm} disabled={loading}>
          {loading ? "Deleting..." : "Delete"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteConfirmModal;